import { createFileRoute } from '@tanstack/react-router'

import { TelephonyProductPage } from '#/modules/telephony/telephony-product-page'
import { telephonySearch } from '#/modules/telephony/telephony-search'

export const Route = createFileRoute('/_shell/numbers')({
  component: TelephonyProductPage,
  validateSearch: telephonySearch('number'),
})
